declare namespace $ {

	type $mol_text__text_bog_fragile_demo_case_1 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo_case['text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_labeler__title_bog_fragile_demo_case_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_fragile_demo_case_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_fragile_demo_case_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_fragile_demo_case_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_row__sub_bog_fragile_demo_case_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_text__text_bog_fragile_demo_case_7 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo_case['verdict'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $bog_fragile_demo_case extends $mol_section {
		Text( ): $mol_text
		Before( ): $mol_labeler
		After( ): $mol_labeler
		Compare( ): $mol_row
		Verdict( ): $mol_text
		level( ): number
		text( ): string
		before( ): $mol_view
		after( ): $mol_view
		verdict( ): string
		content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=case.view.tree.d.ts.map